// Mock data for POSITIV website

export const classes = [
  {
    id: "1",
    name: "Bodypump",
    duration: "60 Min",
    intensity: "Hoch",
    description:
      "Krafttraining mit der Langhantel für den ganzen Körper. Definiert und stärkt alle Hauptmuskelgruppen.",
    image: "/images/bodypump.jpg",
    category: "Kraft",
  },
  {
    id: "2",
    name: "Workout",
    duration: "50 Min",
    intensity: "Hoch",
    description:
      "Intensives Ganzkörper-Workout für maximale Kraft und Ausdauer. Funktionelle Übungen für alle Fitnesslevel.",
    image: "/images/workout.jpg",
    category: "Kraft",
  },
  {
    id: "3",
    name: "Rehasport",
    duration: "45 Min",
    intensity: "Niedrig",
    description:
      "Therapeutisches Training zur Rehabilitation und Vorbeugung. Schonend und effektiv für Ihren Körper.",
    image: "/images/reha.jpg",
    category: "Reha",
  },
  {
    id: "4",
    name: "Cycling",
    duration: "60 Min",
    intensity: "Hoch",
    description:
      "Mitreißendes Indoor-Cycling mit energiegeladener Musik. Verbrennt Kalorien und stärkt die Ausdauer.",
    image: "/images/cycling.jpg",
    category: "Cardio",
  },
  {
    id: "5",
    name: "Jumping",
    duration: "50 Min",
    intensity: "Hoch",
    description:
      "Dynamisches Trampolintraining für Kraft, Koordination und Spaß. Gelenkschonendes Cardio-Workout.",
    image: "/images/jumping.jpg",
    category: "Cardio",
  },
  {
    id: "6",
    name: "Rücken-Fit",
    duration: "60 Min",
    intensity: "Mittel",
    description:
      "Gezieltes Training zur Stärkung der Rückenmuskulatur. Verbessert Haltung und beugt Beschwerden vor.",
    image: "/images/ruecken.jpg",
    category: "Wohlbefinden",
  },
  {
    id: "7",
    name: "Rücken-Mobility",
    duration: "50 Min",
    intensity: "Niedrig",
    description:
      "Sanfte Mobilisationsübungen für einen beweglichen und schmerzfreien Rücken.",
    image: "/images/ruecken-moblity.jpg",
    category: "Wohlbefinden",
  },
  {
    id: "8",
    name: "Mobility",
    duration: "50 Min",
    intensity: "Niedrig",
    description:
      "Ganzheitliches Beweglichkeitstraining für alle Gelenke. Fördert Flexibilität und Regeneration.",
    image: "/images/mobility.jpg",
    category: "Wohlbefinden",
  },
  {
    id: "9",
    name: "Bauch Express",
    duration: "30 Min",
    intensity: "Mittel",
    description:
      "Kurzes, aber intensives Bauchmuskeltraining. Perfekt für eine starke Körpermitte in kürzester Zeit.",
    image: "/images/bauch.jpg",
    category: "Express",
  },
  {
    id: "10",
    name: "BodyProtect",
    duration: "60 Min",
    intensity: "Mittel",
    description:
      "Selbstschutz-Grundlagen kombiniert mit funktionellem Ganzkörpertraining. Für mehr Körpersicherheit, mentale Stärke und bewusste Bewegung – besonders auch für Frauen geeignet.",
    image: "/images/bodyprotect.jpg",
    category: "Wohlbefinden",
  },
];

export const trainers = [
  {
    id: "1",
    name: "Michael Schmidt",
    specialty: "Kraft & Kondition",
    experience: "12 Jahre",
    image:
      "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBneW18ZW58MHx8fHwxNzYyODY5NDgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "2",
    name: "Sarah Weber",
    specialty: "Yoga & Pilates",
    experience: "8 Jahre",
    image:
      "https://images.unsplash.com/photo-1562751362-404243c2eea3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHx3ZWxsbmVzc3xlbnwwfHx8fDE3NjI4Njk0OTV8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "3",
    name: "Thomas Müller",
    specialty: "Boxing & Kampfsport",
    experience: "15 Jahre",
    image:
      "https://images.unsplash.com/photo-1716307035615-1c6465a32ef2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBneW18ZW58MHx8fHwxNzYyODY5NDgyfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "4",
    name: "Lisa Hoffmann",
    specialty: "Ernährung & Wellness",
    experience: "10 Jahre",
    image:
      "https://images.unsplash.com/photo-1545205597-3d9d02c29597?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwyfHx3ZWxsbmVzc3xlbnwwfHx8fDE3NjI4Njk0OTV8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const membershipPlans = [
  {
    id: "1",
    name: "12 Monate Sommer",
    displayName: "12M - Sommer",
    duration: "12 Monate",
    apiName: "12M - Sommer - Platin Label",
    price: "19",
    period: "Woche",
    setupFee: "20",
    popular: true,
    summerPromo: true,
    description:
      "Unser Platin Label Studio ist die ultimative Wahl für diejenigen, die nach höchster Leistung und einem umfassenden Fitnesserlebnis suchen. Jetzt mit unserer exklusiven Sommeraktion.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "12 Wochen gratis",
    ],
  },
  {
    id: "2",
    name: "12 Monate Special Sommer",
    displayName: "12M - Special - Sommer",
    duration: "12 Monate",
    apiName: "12M - Special - Sommer - Platin Label",
    price: "15",
    period: "Woche",
    setupFee: "20",
    isSpecial: true,
    summerPromo: true,
    description:
      "Spezielles Sommerangebot zu vergünstigten Konditionen. Bitte Minderjährigen-Hinweis beachten.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "12 Wochen gratis",
    ],
  },
  {
    id: "3",
    name: "24 Monate Sommer",
    displayName: "24M - Sommer",
    duration: "24 Monate",
    apiName: "24M - Sommer - Platin Label",
    price: "17",
    period: "Woche",
    setupFee: "20",
    summerPromo: true,
    description:
      "Unser langfristiges Sommerangebot für maximale Ersparnis. Binden Sie sich für 24 Monate und profitieren Sie von unserem besten Preis.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "12 Wochen gratis",
      "Bester Preis",
    ],
  },
  {
    id: "4",
    name: "24 Monate Special Sommer",
    displayName: "24M - Special - Sommer",
    duration: "24 Monate",
    apiName: "24M - Special - Sommer - Platin Label",
    price: "13",
    period: "Woche",
    setupFee: "20",
    isSpecial: true,
    summerPromo: true,
    description:
      "Spezielles Langzeit-Sommerangebot zu vergünstigten Konditionen. Bitte Minderjährigen-Hinweis beachten.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "12 Wochen gratis",
      "Bester Preis",
    ],
  },
  {
    id: "5",
    name: "1 Monat - 14 Tage testen",
    displayName: "1M - 14 Tage testen",
    duration: "1 Monat",
    apiName: "1M - 14 Tage testen - Platin Label",
    price: "23",
    period: "Woche",
    setupFee: "20",
    description:
      "Testen Sie unser Platin Label Studio für einen Monat. Du kannst innerhalb von 14 Tagen ohne Kosten widerrufen und Positiv Fitness Wolnzach so risikofrei testen.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "14 Tage Widerrufsrecht",
    ],
  },
  {
    id: "6",
    name: "1 Monat - 14 Tage testen Special",
    displayName: "1M - Special - 14 Tage testen",
    duration: "1 Monat",
    apiName: "1M - Special - 14 Tage testen - Platin Label",
    price: "20",
    period: "Woche",
    setupFee: "20",
    isSpecial: true,
    description:
      "Spezielles Testangebot zu vergünstigten Konditionen. Du kannst innerhalb von 14 Tagen ohne Kosten widerrufen und Positiv Fitness Wolnzach so risikofrei testen. Bitte Minderjährigen-Hinweis beachten.",
    features: [
      "Training in allen Clubs",
      "Zugang zu allen Kursen",
      "Das gesamte Fitnessangebot",
      "Professionelle Trainingsbetreuung",
      "Wellness & Sauna*",
      "Getränkeflat",
      "14 Tage Widerrufsrecht",
    ],
  },
];

export const spaServices = [
  {
    id: "1",
    name: "Tiefengewebsmassage",
    duration: "60 Min",
    price: "120",
    description:
      "Intensive Massage zur Lösung tiefliegender Verspannungen und Förderung der Regeneration.",
  },
  {
    id: "2",
    name: "Hot Stone Therapie",
    duration: "90 Min",
    price: "150",
    description:
      "Entspannende Behandlung mit erhitzten Steinen für tiefe Muskelentspannung.",
  },
  {
    id: "3",
    name: "Aromatherapie-Massage",
    duration: "75 Min",
    price: "135",
    description:
      "Harmonisierende Massage mit ätherischen Ölen für Körper und Geist.",
  },
  {
    id: "4",
    name: "Gesichtsbehandlung Premium",
    duration: "60 Min",
    price: "110",
    description:
      "Anti-Aging Behandlung mit hochwertigen Produkten für strahlende Haut.",
  },
];
